import { accessibleBranches } from '@/utils/activeBranch';
import { ALL_BRANCHES } from '@/utils/branchScope';

// Asks the hub for every branch the operator can reach. The hub resolves it against their own
// grants, so it can never widen what they receive; the backfill, one branch per call, skips it.
export const ALL_REACHABLE_BRANCHES = ALL_BRANCHES;

// Which branches' doors the gate check-in popup listens on.
//
// Pinned in the switcher: that branch. On the all-branches view: every branch the operator can
// reach -- not their home branch, which left an admin covering several sites deaf to all but one
// door. The home branch answers only while the branch list is unavailable (a single-branch club
// never loads it, and a reload mounts the popup before it arrives). With nothing to name at all the
// hub is still asked, rather than the popup quietly never connecting.
export const resolveEntryHubBranchIds = (authState, tenantBranches) => {
  const pinned = authState && authState.activeBranchId;
  if (pinned) return [String(pinned)];

  const reachable = accessibleBranches(authState, tenantBranches).map((b) => String(b.id));
  if (reachable.length) return reachable;

  const home = authState && authState.userData && authState.userData.psDefaultBranch;
  if (home) return [String(home)];

  return [ALL_REACHABLE_BRANCHES];
};

// Whether a queued popup is still about a door the desk watches. Resubscribing drops only the
// popups for branches it stopped watching: clearing everything also wiped the catch-up the first
// subscription delivered when a reload widened it from the home branch to the full list.
export const isWatchedEntry = (entry, branchIds) => {
  const watched = (branchIds || []).map(String);
  if (watched.includes(ALL_REACHABLE_BRANCHES)) return true;
  return !!entry && watched.includes(String(entry.branchId));
};
